module.exports = __webpack_public_path__ + "static/media/image.7c2ec469.png";